/** Engin ou contrôle électrique (bool MySQL 0/1). */
export function isElectrique(value) {
  return value === true || value === 1;
}
